import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  showPaymentMethodForm,
  setDefaultPaymentMethod,
  showConfirmDeletePaymentMethod,
  hideConfirmDeletePaymentMethod,
  deletePaymentMethod,
  showPaymentMethodSelectionForm,
  showSelectPaymentMethodForm,
} from '../../PaymentMethods/paymentMethodsActions';
import CartPaymentMethod from './CartPaymentMethod';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import PaymentMethodsContainer from '../../PaymentMethods/PaymentMethodsContainer';
import {
  showGiftCardModal,
  initiateReloadGiftCard,
  reloadGiftCard,
  resetGiftCardReducer,
} from '../../GiftCard/giftCardActions';
import styled from 'styled-components';
import {
  DELIVERY,
  PICKUP,
  DROPOFF,
} from '../../OrderSetting/OrderSettingModal/utils/helper';

const PaymentMethodsContainerWrapper = styled.div`
  padding: 24px;
  @media (max-width: 786px) {
    padding: 20px;
  }
`;

const styles = () => ({
  scrollPaper: {
    alignItems:
      typeof window !== 'undefined' && window.innerWidth < 786
        ? 'flex-end'
        : 'center',
  },
  paper: {
    margin: 0,
    width: '100%',
    //maxWidth: '100%',
  },
});

const CartPaymentMethodContainer = ({
  paymentMethodsReducer,
  requestingSetDefaultPaymentMethod,
  requestingCreatePaymentMethod,
  classes,
  showPaymentMethodForm,
  isForCheckoutPage,
  isForGiftCard,
  setDefaultPaymentMethod,
  showConfirmDeletePaymentMethod,
  hideConfirmDeletePaymentMethod,
  deletePaymentMethod,
  sourceConfig,
  orderSettingReducer,
  showPaymentMethodSelectionForm,
  showSelectPaymentMethodForm,
  resetGiftCardReducer,
}) => {
  const {
    paymentMethods,
    paymentMethodSelectionFormIsVisible,
    selectedPaymentMethod,
  } = paymentMethodsReducer;
  const {
    interOrderType,
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
  } = orderSettingReducer;

  const isPayOnArrival =
    interOrderType === PICKUP && interPickUpDetails
      ? interPickUpDetails.accepted_order_types_config?.pickup
          .is_loyalty_only_enabled
      : interOrderType === DELIVERY &&
        interDeliveryDetails &&
        interDeliveryDetails.deliveryBusiness
      ? interDeliveryDetails.deliveryBusiness.accepted_order_types_config
          ?.delivery.is_loyalty_only_enabled
      : interOrderType === DROPOFF && interDropOffDetails
      ? interDropOffDetails.accepted_order_types_config?.drop_off
          .is_loyalty_only_enabled
      : null;

  let isLoyaltyOnlyEnabled = null;

  if (interOrderType === PICKUP && orderSettingReducer.interPickUpDetails) {
    isLoyaltyOnlyEnabled =
      orderSettingReducer.interPickUpDetails.accepted_order_types_config?.pickup
        .is_loyalty_only_enabled;
  } else if (
    interOrderType === DELIVERY &&
    orderSettingReducer.interDeliveryDetails
  ) {
    isLoyaltyOnlyEnabled =
      orderSettingReducer.interDeliveryDetails.accepted_order_types_config
        ?.delivery.is_loyalty_only_enabled;
  } else if (
    interOrderType === DROPOFF &&
    orderSettingReducer.interDropOffDetails
  ) {
    isLoyaltyOnlyEnabled =
      orderSettingReducer.interDropOffDetails.accepted_order_types_config
        ?.drop_off.is_loyalty_only_enabled;
  }

  const defaultPaymentMethod =
    paymentMethods && paymentMethods.find(({ is_preferred }) => is_preferred);

  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    window.addEventListener('scroll', listener);
    return () => {
      window.removeEventListener('scroll', listener);
    };
  }, []);

  const listener = () => {
    setScrollY(typeof window !== 'undefined' && window.scrollY);
  };

  useEffect(() => {
    if (!paymentMethodSelectionFormIsVisible) window.scrollTo(0, scrollY);
  }, [paymentMethodSelectionFormIsVisible]);
  return (
    <div>
      {!paymentMethodSelectionFormIsVisible ? (
        <CartPaymentMethod
          id='CartPaymentMethod-CartPaymentMethodComponent'
          paymentMethods={paymentMethods}
          defaultPaymentMethod={defaultPaymentMethod}
          showPaymentMethodForm={showPaymentMethodForm}
          isForCheckoutPage={isForCheckoutPage}
          showGiftCardModal={showGiftCardModal}
          initiateReloadGiftCard={initiateReloadGiftCard}
          reloadGiftCard={reloadGiftCard}
          isForGiftCard={isForGiftCard}
          setDefaultPaymentMethod={setDefaultPaymentMethod}
          paymentMethodSelectionFormIsVisible={
            paymentMethodSelectionFormIsVisible
          }
          showPaymentMethodSelectionForm={showPaymentMethodSelectionForm}
          paymentMethodsReducer={paymentMethodsReducer}
          showConfirmDeletePaymentMethod={showConfirmDeletePaymentMethod}
          hideConfirmDeletePaymentMethod={hideConfirmDeletePaymentMethod}
          deletePaymentMethod={deletePaymentMethod}
          sourceConfig={sourceConfig}
          isLoyaltyOnlyEnabled={isLoyaltyOnlyEnabled}
          selectedPaymentMethod={selectedPaymentMethod}
          showSelectPaymentMethodForm={showSelectPaymentMethodForm}
          resetGiftCardReducer={resetGiftCardReducer}
          isPayOnArrival={isPayOnArrival}
        />
      ) : (
        <Dialog
          aria-labelledby='payment-methods'
          aria-describedby='payment-methods'
          open={paymentMethodSelectionFormIsVisible}
          onBackdropClick={(e) => {
            showPaymentMethodSelectionForm(false);
          }}
          fullWidth={typeof window !== 'undefined' && window.innerWidth < 786}
          classes={{ scrollPaper: classes.scrollPaper }}
          PaperProps={{ classes: { root: classes.paper } }}
          scroll='body'
          // style={{ zIndex: 100000 }}
        >
          <PaymentMethodsContainerWrapper>
            <PaymentMethodsContainer
              noDialogBackground={true}
              isForGiftCard={isForGiftCard}
              isForCheckoutPage={isForCheckoutPage}
              openInModal={true}
              defaultPaymentMethod={defaultPaymentMethod}
              showPaymentMethodSelectionForm={showPaymentMethodSelectionForm}
            />
          </PaymentMethodsContainerWrapper>
        </Dialog>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  paymentMethodsReducer: state.paymentMethodsReducer,
  requestingSetDefaultPaymentMethod:
    state.paymentMethodsReducer.requestingSetDefaultPaymentMethod,
  requestingCreatePaymentMethod:
    state.paymentMethodsReducer.requestingCreatePaymentMethod,
  sourceConfig: state.authReducer.appConfig,
  orderSettingReducer: state.orderSettingReducer,
});

export default withStyles(styles)(
  connect(mapStateToProps, {
    showPaymentMethodForm,
    showGiftCardModal,
    initiateReloadGiftCard,
    reloadGiftCard,
    setDefaultPaymentMethod,
    showConfirmDeletePaymentMethod,
    hideConfirmDeletePaymentMethod,
    deletePaymentMethod,
    showPaymentMethodSelectionForm,
    showSelectPaymentMethodForm,
    resetGiftCardReducer,
  })(CartPaymentMethodContainer)
);
